import React from 'react';
export function SiteFooter() {
  return <footer className="mt-16 w-full border-t border-ink/10 bg-ink text-paper/80" data-id="element-340" data-mp="1dqro3uzoli7a">
      <div className="mx-auto max-w-3xl px-5 py-10" data-id="element-341" data-mp="3r9kgd64mjx6h">
        <p className="mb-4 text-center font-display text-xl font-bold text-paper" data-id="element-342" data-mp="3mh9i07pj8jg1">
          Réveil
        </p>
        <p className="mt-6 text-center text-xs text-paper/40" data-id="element-343" data-mp="3hizn7y7pzkuy">
          © {new Date().getFullYear()} Réveil. All rights reserved.
        </p>
      </div>
    </footer>;
}